module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rlist"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/List#list"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rpreface"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1s",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "rpart01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01#part01"
    }
  }, [_c('strong', [_vm._v("Part I : Ideas")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#chapter01"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v("  Telling About Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#chapter02"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v("  Representations of Society as Organizational Products")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v("  Who Does What?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v("  The Work Users Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v("  Standardization and Innovation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v("  Summarizing Details")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v("  Reality Aesthetics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter08"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v("  The Morality of Representations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rpart02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II : Examples")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc2"
  }, [_c('p', {
    staticClass: "toc-a",
    attrs: {
      "id": "rchapter09"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v("  Parables, Ideal Types, and Mathematical Models")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter10"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10")]), _vm._v("  Charts: Thinking with Drawings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter11"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11")]), _vm._v("  Visual Sociology, Documentary Photography, and Photojournalism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter12"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12")]), _vm._v("  Drama and Multivocality: Shaw, Churchill, and Shawn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter13"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13")]), _vm._v("  Goffman, Language, and the Comparative Strategy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter14"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14")]), _vm._v("  Jane Austen: The Novel as Social Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter15"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15")]), _vm._v("  Georges Perec’s Experiments in Social Description")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-b",
    attrs: {
      "id": "rchapter16"
    }
  }, [_c('span', {
    staticClass: "display"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16")]), _vm._v("  Italo Calvino, Urbanologist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rfinally"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Finally#finally",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finally ….")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rref"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Ref#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rindex"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 69
// module chunks = 0